import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneformat' })
export class PhoneFormatPipe implements PipeTransform {
    transform(phone: string): string {
      if(!phone || phone == "")
        return "";
      return "("+phone.substring(0,3)+") "+phone.substring(3,6)+"-"+phone.substring(6,10);
    }
  }
  